import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';


export const full = 'icon-folder-full';
export const half = 'icon-folder-half';
export const empty = 'icon-folder-empty';
export const thesaurusFolderIconBaseClassName = 'tree-view-dialog-thesaurus-item-icon-folder';


function getFolderIcon (selected, partiallySelected) {
  if (selected) {
    return 'icon-folder-full'
  }

  if (partiallySelected) {
    return 'icon-folder-half';
  }

  return 'icon-folder-empty';
}

export default function ThesaurusFolderIcon (props) {
  const {
    selected,
    partiallySelected,
  } = props;

  const folderIconId = getFolderIcon(selected, partiallySelected);

  return (
    <svg
      className={classnames(
        thesaurusFolderIconBaseClassName,
        `${thesaurusFolderIconBaseClassName}-${folderIconId}`,
      )}
    >
      <use xlinkHref={`#${folderIconId}`} />
    </svg>
  );
}

ThesaurusFolderIcon.propTypes = {
  selected: PropTypes.bool.isRequired,
  partiallySelected: PropTypes.bool.isRequired,
};
